import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import * as CONSTANTS from "../constants";

import LoadingIndicator from '../components/loading-indicator';

export default function CheckForQueue(props) {

    const { instanceId } = useParams();

    const [iframeStyles, setIframeStyles] = useState({display:"none", width: "0px", height: "0px"});
    const [showLoadingIndicator, setShowLoadingIndicator] = useState(true);

    const iframeURL = `${CONSTANTS.DOMAIN_NAME}/${CONSTANTS.CLIENT_NAME}/website/ChooseSeats.aspx?EventInstanceId=${instanceId}`;

    /**
     * Fetch Iframe's URL.
     */

    useEffect(() => {
        const onMessage = (event) => {
            if (event.data?.show_book_online) {
                props.setCheckedForQueue(true);
            }
            
            if (event.data?.show_queue_iframe) {
                setIframeStyles({display: "block", width: "100%", height: "90vh"});
                setShowLoadingIndicator(false);
            }            
        };

        window.addEventListener("message", onMessage);
        return () => {
            window.removeEventListener("message", onMessage);
        };
    }, []);


    return (
        <div className="booking-pathway__queue-check">
            {showLoadingIndicator &&
                <LoadingIndicator type="page" />
            }
            <iframe
                className="spektrix-iframe"
                name="SpektrixIFrame"
                id="SpektrixIFrame"
                src={iframeURL}
                title="Queue"
                style={iframeStyles}
            />
        </div>
    );
}
